module.exports = __webpack_public_path__ + "static/logo-86adfbe87f7eb56a1f54e3ee2b9fb776.jpg";